import React, { useEffect, useState } from "react";
import "./styles.scss";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import {
  Button,
  FormHeader,
  ImageComponent,
  InputBox,
  PDFPreviewer,
  PDFUploader,
  RadioButton,
  TabComponent,
  Uploader,
} from "../../../components";
import { CheckValidity } from "../../../utils/formValidity";
import Sinhala from "./sinhala";
import English from "./english";
import Scrollbars from "react-custom-scrollbars-2";
import CategorySelectBox from "../../templates/categorySelectBox";
import WidgetSelectBox from "../../templates/widgetSelectBox";
import GalleryUploader from "../../templates/galleryUploader";
import {
  createNewNews,
  createNewNewsMulti,
  updateNews,
  updateNewsMulti,
} from "../../news/service/news.service";
import { Store } from "react-notifications-component";
import { useDispatch, useSelector } from "react-redux";
import { clearSelectNews } from "../../news/redux/actions";
import { deleteImage } from "../../../components/imageComponent/service/upload.service";
import TagsSelectBox from "../../templates/tagsSelectBox";
import {
  openCreateTagModal,
  openSelectTagsModal,
} from "../../Tags/redux/actions";
import { getLanguage } from "../../../utils";

const lan = getLanguage();

const CreateNewNews = ({ data }) => {
  // const dispatch = useDispatch();
  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);
  const [finish, setFinish] = useState(true);
  const [language, setLanguage] = useState(lan);
  const [useLanguage, setUseLanguage] = useState(lan);
  const [selectTagList, setSelectTagList] = useState([]);
  const [selectedTagList, setSelectedTagList] = useState([]);
  const [pdf, setPdf] = useState([]);
  const [formData, setFormData] = useState({
    category: {
      key: "category",
      label: "Category",
      size: "lg",
      placeholder: "-",
      mainLayerStyles: " flex-column align-content-center mb-3",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    widget: {
      key: "widget",
      label: "Widget",
      size: "lg",
      placeholder: "Select Widgets",
      mainLayerStyles: " flex-column align-content-center mb-3",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    url: {
      key: "url",
      label: "Youtube URL",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    code: {
      key: "code",
      label: "YouTube embed code",
      size: "lg",
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    titleSI: {
      key: "titleSI",
      label: "Title (SI)",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
      mainLayerStyles: "mb-3",
    },
    descriptionSI: {
      key: "descriptionSI",
      label: "Description (SI)",
      size: "lg",
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    titleEN: {
      key: "titleEN",
      label: "Title (EN)",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
      mainLayerStyles: "mb-3",
    },
    descriptionEN: {
      key: "descriptionEN",
      label: "Description (EN)",
      size: "lg",
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    keyWordSI: {
      key: "keyWord",
      label: "",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
      mainLayerStyles: "mb-3",
    },
    keyWordEN: {
      key: "keyWord",
      label: "",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
      mainLayerStyles: "mb-3",
    },
    imageUrl: {
      key: "imageUrl",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "Type your image URL",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    PDFUrl: {
      key: "PDFUrl",
      label: "",
      size: "lg disable",
      isShowRequired: false,
      disabled: true,
      // btnName: "delete",
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const [imageGallery, setImageGallery] = useState([]);
  const [image, setImage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { selectNews, isOpenAddUpdateNewsModal, isOpenNewsViewModal } =
    useSelector(({ newsReducer }) => newsReducer);

  const { selectedTags, tagsList } = useSelector(
    ({ tagsReducer }) => tagsReducer
  );

  const dispatch = useDispatch();

  const handleChange = async (event, inputIdentity) => {
    const updateNewsForm = {
      ...formData,
    };

    updateNewsForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateNewsForm[inputIdentity].value,
      updateNewsForm[inputIdentity].validation
    );

    if (validityRes) {
      updateNewsForm[inputIdentity].isValid = validityRes.isValid;
      updateNewsForm[inputIdentity].invalidReason = validityRes.reason;
      updateNewsForm[inputIdentity].value = event;
      updateNewsForm[inputIdentity].touched = true;
      console.log("required_validation", validityRes);

      let formIsValid = false;
      for (let inputIdentifier in updateNewsForm) {
        formIsValid = updateNewsForm[inputIdentifier].valid && formIsValid;
      }
      console.log("formIsValid", formIsValid);
      setFormData(updateNewsForm);
    }
  };

  const clearAll = () => {
    const updateNewsForm = {
      ...formData,
    };
    for (let key in updateNewsForm) {
      updateNewsForm[key].value = "";
      updateNewsForm[key].isValid = false;
      updateNewsForm[key].touched = false;
    }
    setImage([]);
    setImageGallery([]);
    setFinish(true);
    setSelectTagList([]);
    setPdf([]);
    setFormData(updateNewsForm);
  };

  const onClickAdd = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    const updateForm = { ...formData };
    if (updateForm.imageUrl.value === "") {
      setIsLoading(false);
      return;
    }
    let file = {
      url: updateForm.imageUrl.value,
      caption: {
        si: updateForm.imageUrl.value,
        en: updateForm.imageUrl.value,
      },
    };
    setImage([file]);
    setFormData({
      ...formData,
      imageUrl: {
        ...formData.imageUrl,
        value: "",
        isValid: false,
        touched: false,
      },
    });
    setIsLoading(false);
  };

  const onClickSave = async () => {
    setIsLoading(true);

    const updateNewsForm = {
      ...formData,
    };

    let body = {
      title: {
        si: updateNewsForm.titleSI.value,
        en: updateNewsForm.titleEN.value,
      },
      content: {
        si: updateNewsForm.descriptionSI.value,
        en: updateNewsForm.descriptionEN.value,
      },
      author: "Damith",
      tags: selectTagList,
      category: updateNewsForm.category.value,
      widget: updateNewsForm.widget.value,
      status: "Draft",
      images: image,
      gallery: imageGallery,
      youtube_url: updateNewsForm.url.value,
      youtube_embed_code: updateNewsForm.code.value,
      attachments: pdf,
      language: useLanguage,
      keywords: {
        si: updateNewsForm.keyWordSI.value,
        en: updateNewsForm.keyWordEN.value,
      },
    };

    console.log("news body::", body);
    try {
      const response = await createNewNews(body);
      if (useLanguage === "multi") {
        await createNewNewsMulti(body);
      }
      if (response?.data) {
        Store.addNotification({
          title: "Success!",
          message: "News Create Successfully!",
          type: "success",
          insert: "top",
          container: "top-right",
          dismiss: { duration: 3000, onScreen: true },
        });
        setIsLoading(false);
        setFinish(true);
        clearAll();
      }
    } catch (error) {
      console.error("Error creating news:", error);
      setIsLoading(false);
      Store.addNotification({
        title: "Error!",
        message: "Error creating news",
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: {
          duration: 2000,
          onScreen: true,
        },
      });
    }
  };

  const onClickUpdate = async () => {
    setIsLoading(true);
    if (selectNews?.news_id) {
      const updateNewsForm = {
        ...formData,
      };

      let body = {
        title: {
          si: updateNewsForm.titleSI.value,
          en: updateNewsForm.titleEN.value,
        },
        content: {
          si: updateNewsForm.descriptionSI.value,
          en: updateNewsForm.descriptionEN.value,
        },
        author: "Damith",
        tags: selectTagList,
        category: updateNewsForm.category.value,
        widget: updateNewsForm.widget.value,
        status: "Draft",
        images: image,
        gallery: imageGallery,
        youtube_url: updateNewsForm.url.value,
        youtube_embed_code: updateNewsForm.code.value,
        attachments: pdf,
        language: useLanguage,
        keywords: {
          si: updateNewsForm.keyWordSI.value || "",
          en: updateNewsForm.keyWordEN.value || "",
        },
      };

      console.log("news body::", body);
      try {
        const response = await updateNews(body, selectNews?.news_id);
        // if (useLanguage === "multi") {
        //   await updateNewsMulti(body, selectNews?.news_id);
        // }
        if (response?.data) {
          Store.addNotification({
            title: "Success!",
            message: "News Update Successfully!",
            type: "success",
            insert: "top",
            container: "top-right",
            dismiss: { duration: 3000, onScreen: true },
          });
          setIsLoading(false);
          setFinish(true);
          clearAll();
          dispatch(clearSelectNews());
        }
      } catch (error) {
        console.error("Error creating news:", error);
        setIsLoading(false);
        Store.addNotification({
          title: "Error!",
          message: "Error creating news",
          type: "danger",
          insert: "top",
          container: "top-right",
          dismiss: {
            duration: 2000,
            onScreen: true,
          },
        });
      }
    }
  };

  const updateNewsForm = { ...formData };

  // scrollbars start
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  };

  const handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };
  // scrollbars end

  const categorySelect = (value) => {
    console.log({ value });
    const updateNewsForm = { ...formData };
    updateNewsForm["category"].value = value;
    setFormData(updateNewsForm);
  };

  const widgetSelect = (value) => {
    console.log({ value });
    const updateNewsForm = { ...formData };
    updateNewsForm["widget"].value = value;
    setFormData(updateNewsForm);
  };

  const tagsSelect = (tags) => {
    setSelectTagList(tags);
  };

  const onChangeImageGallery = (gallery) => {
    if (gallery) {
      setImageGallery(gallery);
    }
  };

  const onChangePDF = (file) => {
    if (file) {
      setPdf([...pdf, file]);

      let updateFormData = { ...formData };
      updateFormData.PDFUrl.value = file?.file_url;
      setFormData(updateFormData);
    }
  };

  const onChangeImage = (image) => {
    try {
      if (image) {
        let file = {
          url: image.file_url,
          caption: {
            si: image.file_name,
            en: image.file_name,
          },
        };
        setImage([file]);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const onClickRemoveImage = async (key) => {
    setIsLoading(true);
    try {
      const res = await deleteImage(key);
      console.log("remove image", res);

      if (res?.data) {
        Store.addNotification({
          title: "Success",
          message: "Image Delete successfully",
          type: "success",
          container: "top-right",
          dismiss: {
            duration: 2000,
            onScreen: true,
          },
        });
      }

      setImage((prev) => {
        return prev.filter((item) => item.key !== key);
      });
      setIsLoading(false);
    } catch (error) {
      console.log("Error in deleting image", error);
      Store.addNotification({
        title: "Error",
        message: "Image Delete failed",
        type: "danger",
        container: "top-right",
        dismiss: {
          duration: 2000,
          onScreen: true,
        },
      });
      setIsLoading(false);
    }
  };

  const onChangeSI = (form) => {
    if (form) {
      setFormData({
        ...formData,
        titleSI: form.titleSI,
        descriptionSI: form.descriptionSI,
        keyWordSI: form.keyWord,
      });
      setFinish(false);
    }
  };

  const onChangeEN = (form) => {
    if (form) {
      setFormData({
        ...formData,
        titleEN: form.titleEN,
        descriptionEN: form.descriptionEN,
        keyWordEN: form.keyWord,
      });
      setFinish(false);
    }
  };

  const fetchTagName = (id) => {
    const isExist = tagsList?.find((x) => x?.tag_id === id);
    return isExist?.tag_name;
  };

  const onChange = (key) => {
    setLanguage(key);
  };

  const items = [
    {
      key: "si",
      label: "Sinhala",
      children: <Sinhala finish={finish} onChange={onChangeSI} />,
    },
    {
      key: "en",
      label: "English",
      children: <English finish={finish} onChange={onChangeEN} />,
    },
  ];

  useEffect(() => {
    clearAll();
    dispatch(clearSelectNews());
  }, []);

  useEffect(() => {
    if (selectedTags?.length > 0) {
      setSelectTagList([...selectTagList, ...selectedTags]);
    } else {
      setSelectTagList([]);
    }
  }, [selectedTags]);

  useEffect(() => {
    if (
      selectNews?.news_id &&
      !isOpenAddUpdateNewsModal &&
      !isOpenNewsViewModal
    ) {
      let updateFormData = { ...formData };
      updateFormData.category.value = selectNews?.category;
      updateFormData.widget.value = selectNews?.widget;
      updateFormData.titleSI.value = selectNews?.title["si"];
      updateFormData.descriptionSI.value = selectNews?.content["si"];
      updateFormData.titleEN.value = selectNews?.title["en"];
      updateFormData.descriptionEN.value = selectNews?.content["en"];
      updateFormData.url.value = selectNews?.youtube_url;
      updateFormData.code.value = selectNews?.youtube_embed_code;
      updateFormData.PDFUrl.value =
        selectNews?.attachments?.[0]?.file_url || "";
      updateFormData.keyWordSI.value = selectNews?.keywords?.["si"];
      updateFormData.keyWordEN.value = selectNews?.keywords?.["en"];
      setSelectTagList([]);
      setPdf(selectNews.attachments || []);
      setImage(selectNews.images);
      setImageGallery(selectNews.gallery);
      setUseLanguage(selectNews?.language);
      setSelectedTagList(selectNews?.tags || []);
      setFormData(updateFormData);
    } else {
      clearAll();
    }
  }, [selectNews]);

  return (
    <>
      <div className="hne-create-news-wrapper">
        <FormHeader
          data={{
            formHeader: "Create new news",
            size: "md-md",
          }}
        />
        <Scrollbars
          onScroll={handleOnScroll}
          renderView={(props) => (
            <div {...props} style={{ ...props.style, overflowX: "hidden" }} />
          )}
          style={{ height: viewPointHeight - 250 }}
        >
          <div style={{ paddingBottom: "42px", paddingRight: "16px" }}>
            <>
              <div className={"hne-cnw-radio-button-wrapper"}>
                {language === "si" && (
                  <RadioButton
                    data={{
                      name: "Sinhala",
                      isActive: useLanguage === "si",
                    }}
                    onClick={() => {
                      setUseLanguage("si");
                      onChange("si");
                    }}
                  />
                )}
                <RadioButton
                  data={{
                    name: "English",
                    isActive: useLanguage === "en",
                  }}
                  onClick={() => {
                    setUseLanguage("en");
                    onChange("en");
                  }}
                />
                <RadioButton
                  data={{
                    name: "Multiple",
                    isActive: useLanguage === "multi",
                  }}
                  onClick={() => {
                    setUseLanguage("multi");
                  }}
                />
              </div>
              {/* <DropBox
                data={updateNewsForm.category}
                onChange={(e) => {
                  const updateNewsForm = { ...formData };
                  updateNewsForm["category"].value = e;
                  setFormData(updateNewsForm);
                  // dispatch(setCategoryDetails(e));
                }}
              /> */}
              <CategorySelectBox
                onChangeCategory={categorySelect}
                data={{
                  language: language,
                }}
              />
            </>
            <>
              <TabComponent
                items={lan === "si" ? items : [items?.[1]]}
                onChange={onChange}
              />
            </>

            <div className={"hne-cnw-youtube "}>
              <div
                className="d-flex justify-content-end align-items-end mt-2"
                style={{
                  marginBottom: "-25px",
                  position: "relative",
                  zIndex: "90",
                }}
              >
                <Button
                  data={{
                    btnName: "Select Tags",
                    buttonType: "secondary s-border",
                    buttonSize: "xs x mr-2",
                    // isLoading: isLoading,
                  }}
                  onClick={(e) => {
                    dispatch(openSelectTagsModal());
                  }}
                />
                <Button
                  data={{
                    btnName: "Create New",
                    buttonType: "secondary s-border",
                    buttonSize: "xs x",
                    // isLoading: isLoading,
                  }}
                  onClick={(e) => {
                    dispatch(openCreateTagModal());
                  }}
                />
              </div>
              <TagsSelectBox
                onChangeTag={tagsSelect}
                tagList={selectedTagList || []}
                data={{
                  language: language,
                }}
              />
              {/* {selectedTags?.length > 0 && selectTagList?.length > 0 && (
                <div className="d-flex flex-row flex-wrap mb-2">
                  {selectTagList.map((tag) => (
                    <div className="ml-2 mb-1">
                      <Tag
                        key={tag}
                        data={{
                          tagName: fetchTagName(tag),
                          tagIcon: "",
                          type: "primary",
                          isIcon: true,
                        }}
                        onClick={() => {
                          const newList = selectTagList.filter(
                            (item) => item !== tag
                          );
                          setSelectTagList(newList);
                        }}
                      />
                    </div>
                  ))}
                </div>
              )} */}

              <WidgetSelectBox
                onChangeWidget={widgetSelect}
                data={{
                  language: language,
                  widget_id: updateNewsForm.widget.value,
                }}
              />

              <InputBox
                data={updateNewsForm.url}
                onChange={async (e) => {
                  e.preventDefault();
                  await handleChange(e.target.value, updateNewsForm.url.key);
                }}
              />
              <div className={"d-flex flex-column justify-content-start"}>
                <InputBox
                  data={updateNewsForm.code}
                  onChange={async (e) => {
                    e.preventDefault();
                    await handleChange(e.target.value, updateNewsForm.code.key);
                  }}
                />
                <div className={"uploader-lable"}>Banner image (1000x 720)</div>
                <div className="d-flex flex-row align-items-center justify-content-between">
                  <InputBox
                    data={updateNewsForm.imageUrl}
                    onChange={async (e) => {
                      e.preventDefault();
                      await handleChange(
                        e.target.value,
                        updateNewsForm.imageUrl.key
                      );
                    }}
                  />
                  <div className="d-flex ml-2">
                    <Button
                      data={{
                        btnName: "Add",
                        buttonType: "secondary",
                        buttonSize: "md",
                        isLoading: isLoading,
                        disable:
                          updateNewsForm.imageUrl.value === "" ||
                          !updateNewsForm.imageUrl.isValid,
                      }}
                      onClick={async (e) => {
                        e.preventDefault();
                        await onClickAdd(e);
                      }}
                    />
                  </div>
                </div>
                <div className={"d-flex"}>
                  {image?.length > 0 && (
                    <>
                      <ImageComponent
                        data={{ size: "md mt-3", imgUrl: image?.[0]?.url }}
                        onClickRemove={() => {
                          onClickRemoveImage(
                            image?.[0]?.caption?.si || image?.[0]?.caption?.en
                          );
                        }}
                      />
                    </>
                  )}
                  {/*{image?.length === 0 && (*/}
                  <Uploader
                    data={{
                      disabled: false,
                      isLable: true,
                      // uploaderLable: "Banner image (1000x 720)",
                      iconName: "upload-cloud",
                    }}
                    onChange={onChangeImage}
                  />
                  {/*)}*/}
                </div>
              </div>

              {/* <div className={"hne-cnw-uploader d-flex flex-column"}>
                <div className={"hne-cnwu-lable"}>{"Gallery (1024x1024)"}</div>
                <div className={"d-flex flex-row"} style={{ gap: "7px" }}>
                  <Uploader
                    data={{
                      disabled: false,
                      isLable: false,
                      iconName: "upload-cloud",
                    }}
                  />
                  <Uploader
                    data={{
                      disabled: false,
                      isLable: false,
                      iconName: "upload-cloud",
                    }}
                  />
                </div>
              </div> */}
              <GalleryUploader
                data={{
                  images: imageGallery,
                }}
                onChange={onChangeImageGallery}
              />
              <div className={"hne-cnw-uploader d-flex flex-column"}>
                <div className={"hne-cnwu-lable"}>{"Attachment"}</div>
                <div className={"d-flex flex-row"} style={{ gap: "7px" }}>
                  <PDFUploader
                    data={{
                      disabled: false,
                      isLable: false,
                      iconName: "upload-cloud",
                      // key: "pdfUploader",
                    }}
                    onChange={onChangePDF}
                  />
                </div>
                {pdf?.length > 0 && (
                  <PDFPreviewer
                    data={{
                      attachments: pdf,
                      size: "lg mt-3",
                    }}
                    setPDFList={(newList) => {
                      setPdf(newList);
                    }}
                  />
                )}
                {pdf?.length > 0 && (
                  <div className={"d-flex flex-column"} style={{ gap: "10px" }}>
                    <label className={"txt-label"}>PDF URL</label>
                    {pdf.map((item, index) => (
                      <>
                        <InputBox
                          data={{
                            ...updateNewsForm.PDFUrl,
                            btnCopy: "Copy Link",
                            value: item.file_url,
                          }}
                          onChange={async (e) => {
                            e.preventDefault();
                            await handleChange(
                              e.target.value,
                              updateNewsForm.PDFUrl.key
                            );
                          }}
                        />
                      </>
                    ))}
                  </div>
                )}
                {/* <InputBox
                  data={updateNewsForm.PDFUrl}
                  onChange={async (e) => {
                    e.preventDefault();
                    await handleChange(
                      e.target.value,
                      updateNewsForm.PDFUrl.key
                    );
                  }}
                /> */}
              </div>
            </div>
          </div>
        </Scrollbars>
        <div
          className="d-flex flex-row justify-content-between"
          style={{ marginBottom: "15px" }}
        >
          {!isOpenAddUpdateNewsModal && selectNews?.news_id && (
            <Button
              data={{
                btnName: "Clear",
                buttonType: "secondary mr-2",
                buttonSize: "lg",
                isLoading: isLoading,
              }}
              onClick={async (e) => {
                e.preventDefault();
                if (selectNews?.news_id) {
                  dispatch(clearSelectNews());
                  setFinish(true);
                  setUseLanguage("si");
                  setImage([]);
                  setImageGallery([]);
                  const updateNewsForm = {
                    ...formData,
                  };
                  for (let key in updateNewsForm) {
                    updateNewsForm[key].value = "";
                    updateNewsForm[key].isValid = false;
                    updateNewsForm[key].touched = false;
                  }
                  setFormData(updateNewsForm);
                }
              }}
            />
          )}
          <Button
            data={{
              btnName:
                !isOpenAddUpdateNewsModal &&
                !isOpenNewsViewModal &&
                selectNews?.news_id
                  ? "Update"
                  : "Done",
              buttonType:
                useLanguage === "" || updateNewsForm.category.value === ""
                  ? "primary disabled"
                  : useLanguage === "multi"
                  ? updateNewsForm.descriptionEN.value === "" ||
                    updateNewsForm.descriptionSI.value === "" ||
                    updateNewsForm.titleEN.value === "" ||
                    updateNewsForm.titleSI.value === ""
                    ? "primary disabled"
                    : "primary"
                  : useLanguage === "si"
                  ? updateNewsForm.descriptionSI.value === "" ||
                    updateNewsForm.titleSI.value === ""
                    ? "primary disabled"
                    : "primary"
                  : useLanguage === "en"
                  ? updateNewsForm.descriptionEN.value === "" ||
                    updateNewsForm.titleEN.value === ""
                    ? "primary disabled"
                    : "primary"
                  : "primary",
              buttonSize: "lg",
              isLoading: isLoading,
              disable:
                useLanguage === "" || updateNewsForm.category.value === ""
                  ? true
                  : useLanguage === "multi"
                  ? updateNewsForm.descriptionEN.value === "" ||
                    updateNewsForm.descriptionSI.value === "" ||
                    updateNewsForm.titleEN.value === "" ||
                    updateNewsForm.titleSI.value === ""
                    ? true
                    : false
                  : useLanguage === "si"
                  ? updateNewsForm.descriptionSI.value === "" ||
                    updateNewsForm.titleSI.value === ""
                    ? true
                    : false
                  : useLanguage === "en"
                  ? updateNewsForm.descriptionEN.value === "" ||
                    updateNewsForm.titleEN.value === ""
                    ? true
                    : false
                  : false,
            }}
            onClick={async (e) => {
              e.preventDefault();
              if (selectNews?.news_id) {
                await onClickUpdate(e);
              } else {
                await onClickSave(e);
              }
            }}
          />
        </div>
      </div>
    </>
  );
};
export default withRouter(CreateNewNews);
